import { MutableRefObject, useEffect, useRef } from 'react';
import Croppie from 'croppie';

interface Props {
    width: number;
    height: number;
    imageWidth: number;
    imageHeight: number;
    file: any;
    scaleResult?: boolean;
    resultRef: MutableRefObject<AnyFunction>;
}

const ImageResize: FC<Props> = ({ file, scaleResult, width, height, imageWidth, imageHeight, resultRef }) => {
    const croppie = useRef(null);
    const ref = useRef(null);

    useEffect(() => {
        if (ref.current && !croppie.current) {
            croppie.current = new Croppie(ref.current, {
                boundary: {
                    width,
                    height,
                },
                viewport: {
                    width: imageWidth,
                    height: imageHeight,
                    type: 'square',
                },
                enforceBoundary: false,
                showZoomer: false,
            });
        }
    }, [ref.current]);

    useEffect(() => {
        if (croppie.current && file) {
            const fileReader = new FileReader();

            fileReader.onload = (e: any) => {
                return croppie.current.bind({ url: e.target.result });
            };

            fileReader.readAsDataURL(file);
        }
    }, [croppie.current, file]);

    // eslint-disable-next-line no-param-reassign
    resultRef.current = () =>
        croppie.current.result({
            type: 'blob',
            size: scaleResult ? 'viewport' : 'original',
        });

    return (
        <div className="image-resize">
            <div ref={ref} />
        </div>
    );
};

export default ImageResize;
